// extracted by mini-css-extract-plugin
export default {"errorWrapper":"errors_errorWrapper__u9id9","not-found":"errors_not-found__yxLkD"};